import React, { ReactElement } from 'react';
import Link from 'next/link';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import { EventDetails } from 'sections/Events/components/EventDetails';
import { eventDetailsData } from 'sections/Events/GlobalFreightSummit/data';
import styles from 'sections/Events/GlobalFreightSummit/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mode="light"
          links={[
            { title: 'Events', href: '/events' },
            { title: 'Global Freight Summit 2024', href: '' },
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__description')}>
            <p className={cn('header__description-suptitle')}>events</p>
            <h1 className={cn('header__description-title')}>Global Freight Summit</h1>
            <div className={cn('header__description-buttons-box')}>
              <Link
                className={cn('header__description-button')}
                href="https://www.theglobalfreightsummit.com/event/2024/regProcessStep1:09ce1b97-373a-42d2-bb5b-6db904974f39?rt=Y2OM2JipKUKQ_o7j_ZKkYQ"
              >
                Register
              </Link>
            </div>
          </div>
          <div className={cn('header__event-details-wrap')}>
            <EventDetails eventDetailsData={eventDetailsData}/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;